// import { DatePicker } from '@/entities/datePicker/ui/DatePicker'
// import { BaseCard, BaseProgressBar, InfoCard } from '@/shared/components'
// import { Skeleton } from '@/shared/components/shadcn'
// import { useIsMobile } from '@/shared/utils/useIsMobile/useIsMobile'
// import { useState } from 'react'
// import { AdminRequisitFarmListPayload } from 'syncra-api-client'
//
// interface Props {
//   farm: AdminRequisitFarmListPayload
//   isLoading?: boolean
// }
//
// export const FarmStatsBanner = ({ farm, isLoading }: Props) => {
//   const isMobile = useIsMobile()
//   const now = new Date()
//
//   const initialDateUtc = new Date(
//     Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
//   ).toISOString()
//
//   const [selectedDate, setSelectedDate] = useState<string>(initialDateUtc)
//   const [type, setType] = useState<'day' | 'month'>('day')
//
//
//   const stat = type === 'day' ? farm.dailyStatistic : farm.monthlyStatistic
//
//   const infomations = stat
//     ? [
//         {
//           id: 1,
//           key: 'Конверсия',
//           value:
//             stat.counterIn > 0
//               ? `${((stat.counterInSuccess / stat.counterIn) * 100).toFixed(1)}%`
//               : '0%',
//         },
//         {
//           id: 2,
//           key: 'Входящие сделки',
//           value: `${stat.counterInSuccess} / ${stat.counterIn}`,
//         },
//         {
//           id: 3,
//           key: 'Средняя сумма',
//           value:
//             stat.counterInSuccess > 0
//               ? `${Math.round(stat.amountIn / stat.counterInSuccess).toLocaleString()}`
//               : `0`,
//         },
//       ]
//     : [
//         { id: 1, key: 'Конверсия', value: '0' },
//         { id: 2, key: 'Входящие сделки', value: '0 / 0' },
//         { id: 4, key: 'Средняя сумма', value: '0 RUB' },
//       ]
//
//   return (
//     <BaseCard padding={isMobile ? 'sm' : 'md'} className="flex flex-col gap-6 w-full">
//       <div className="flex justify-between w-full">
//         <div className="flex md:flex-row flex-col md:justify-between md:items-center gap-4 w-full">
//           <div className="font-medium">Показатели фермы</div>
//           <DatePicker
//             defaultValue={now}
//             onDateChange={(date, type) => {
//               setSelectedDate(date.toISOString())
//               setType(type)
//             }}
//           />
//         </div>
//       </div>
//
//       {isLoading ? (
//         <>
//           <Skeleton className="mb-4 w-[370px] h-[100px]" />
//           <div className="flex md:flex-row flex-col gap-6">
//             <Skeleton className="w-[200px] h-[100px]" />
//             <Skeleton className="w-[200px] h-[100px]" />
//             <Skeleton className="w-[200px] h-[100px]" />
//             <Skeleton className="w-[200px] h-[100px]" />
//           </div>
//         </>
//       ) : (
//         <>
//           <div className="md:max-w-fit">
//             <div className="flex justify-between mb-4">
//               <span className="text-sm">Оборот</span>
//               <div className="bg-primary dark:bg-primary-dark px-2 py-1 border-[1px] border-card-border dark:border-card-border-dark rounded-lg font-klein font-medium text-white text-xs">
//                 Выполнен на {(((stat?.amountIn ?? 0) / (farm.farm?.maxDailyLimit ?? 0)) * 100).toFixed(1)} %
//               </div>
//             </div>
//             <BaseProgressBar
//               variant={'full'}
//               currentBalance={stat?.amountIn ?? 0}
//               totalBalance={farm.farm?.maxDailyLimit ?? 0}
//               textClasses="!text-[20px]"
//             />
//           </div>
//           <div className="flex md:flex-row flex-col gap-x-4 gap-y-[10px] pb-2 md:max-w-[700px] lg:max-w-[900px] 2xl:max-w-[1200px] overflow-x-auto whitespace-nowrap custom-scrollbar">
//             {infomations.map((info) => (
//               <InfoCard key={info.id} title={info.key} value={info.value} />
//             ))}
//           </div>
//         </>
//       )}
//     </BaseCard>
//   )
// }

import { AdminRequisitFarmDetailPayload } from 'syncra-api-client'
import { BaseCard, InformationStatisticCards } from '@/shared/components'
import { formatCurrency } from '@/shared/lib'
import { DatePickerWithRange } from '@/entities/datePicker'
import { useIsMobile } from '@/shared/utils/useIsMobile/useIsMobile'
import { formatTimeFromSeconds } from '@/shared/lib/date/formatDate.ts'
import { DateRange } from 'react-day-picker'
import { useSelector } from 'react-redux'
import { InfoCard } from '@/shared/components/InformationStatisticCards/InformationStatisticCards'
import { Currencies } from '@/entities/curency'
import { selectRatesInfo } from '@/entities/exchangeRates'
import { formatUSDT } from '@/shared/lib/currency/formatUSDT'
import { formatterRub } from '@/shared/utils'

interface FarmStatsBannerProps {
  farm: AdminRequisitFarmDetailPayload
  isLoading?: boolean
  dateRange: DateRange | undefined
  onDateChange: (range: DateRange | undefined) => void
}

export const FarmStatsBanner = ({
  farm,
  isLoading,
  dateRange,
  onDateChange,
}: FarmStatsBannerProps) => {
  const isMobile = useIsMobile()

  const topupSummary = farm.topupSummary

  // Конверсия: paidCount / totalCount
  const conversion =
    topupSummary?.totalCount && topupSummary.totalCount > 0
      ? (((topupSummary.paidCount || 0) / topupSummary.totalCount) * 100).toFixed(1)
      : '0'

  // Средняя сумма заявки: paidAmountFrom / paidCount
  const averageAmount =
    topupSummary?.paidCount && topupSummary.paidCount > 0
      ? (topupSummary.paidAmountFrom || 0) / topupSummary.paidCount
      : 0

  const infoCards: InfoCard[] = [
    {
      id: 1,
      key: 'Конверсия',
      value: `${conversion}%`,
    },
    {
      id: 2,
      key: 'Входящие сделки',
      value: `${formatterRub.format(topupSummary?.paidCount || 0)} / ${formatterRub.format(topupSummary?.totalCount || 0)}`,
    },
    {
      id: 3,
      key: 'Время подтверждения сделки',
      value: formatTimeFromSeconds(
        parseInt(topupSummary?.paidAverageConfirmSeconds?.toFixed() || '0')
      ),
    },
    {
      id: 4,
      key: 'Средняя сумма',
      value: formatCurrency(
        parseInt(averageAmount.toFixed()),
        farm.farm?.farm?.currency || Currencies.RUB
      ),
    },
  ]

  const currentBalance = topupSummary?.paidAmountFrom ?? 0
  const { payInRate, lastUpdatedShort } = useSelector(selectRatesInfo)
  const rate = parseFloat(payInRate.replace('RUB', '').trim())
  const amountUsdt = formatUSDT(currentBalance / rate)

  if (isLoading) {
    return (
      <div className="bg-light-purple dark:bg-dark-purple p-6 rounded-2xl animate-pulse h-[120px]" />
    )
  }

  return (
    <BaseCard padding={isMobile ? 'sm' : 'md'} className="flex flex-col gap-8 w-full">
      {isMobile ? (
        <div className="flex flex-col gap-2">
          <div className="font-medium w-full">Показатели фермы</div>
          <DatePickerWithRange defaultValue={dateRange} onDateChange={onDateChange} />
        </div>
      ) : (
        <div className="flex justify-between items-center">
          <div className="font-medium">Показатели фермы</div>
          <DatePickerWithRange
            className="justify-center max-w-[300px] ml-auto"
            defaultValue={dateRange}
            onDateChange={onDateChange}
          />
        </div>
      )}

      <div>
        <div className="flex gap-[10px] mb-4">
          <span className={'font-medium pt-1'}>Оборот</span>
        </div>

        <div className="flex flex-col w-fit mb-[40px] gap-2">
          <div className="font-klein font-medium text-text-main md:text-[28px] dark:text-white text-2xl">
            <span>{formatterRub.format(currentBalance)} RUB</span>
          </div>
          <div className="mb-2 text-text-main dark:text-white text-sm md:text-base">
            <span className="mr-2"> ~ {amountUsdt}</span>
            <span className="text-text-secondary">
              по курсу {payInRate} на {lastUpdatedShort}
            </span>
          </div>
        </div>

        <InformationStatisticCards infoCards={infoCards} />
      </div>
    </BaseCard>
  )
}
